// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
export default React.forwardRef(function ArrowUpShare(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "ArrowUpShare" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.93999 7.05842L11.9995 2L17.06 7.05833L15.2937 8.82714L13.2495 6.78386V16.1032H10.7495V6.78424L8.70748 8.82715L6.93999 7.05842ZM15.985 12.5V10H20.5V22H3.5V10H8V12.5H6V19.5H18V12.5H15.985Z", fill: "currentColor" }))));
});
//# sourceMappingURL=ArrowUpShare.js.map